import * as modelPicker from "./index";
import { ThreeView } from "../index";
import { ModelDragController, ModelRotateController } from "../ItemDrag";
import { IconTransformControls } from "../controls/IconTransformControls";
import { IconWallItemDragControls } from "../controls/IconWallItemDragControls";
import { IconDragControls } from "../controls/IconDragControls";

export class PickerManager {

    private _picker: modelPicker.Picker;
    public _showPicker: boolean = false;

    constructor() {}

    public createPicker(object: THREE.Object3D, origin: THREE.Vector3, canRotate: boolean, sizeIcon: boolean, duplicateIcon: boolean, textIcon: boolean) {
        this._picker = new modelPicker.Picker(1, ThreeView.get().container, object, origin, canRotate, sizeIcon, duplicateIcon, textIcon, ThreeView.get().eventDispatcher);
        this._showPicker = true;
    }

    public removePicker() {
        this._showPicker = false;
        if (this._picker != null) {
            this._picker.removed();
            this._picker = undefined;
        }
    }

    public hasPicker() {
        return this._picker != null;
    }

    public visible() {
        return this._showPicker;
    }

    public show() {
        this._showPicker = true;
    }

    public hide() {
        this._showPicker = false;
        if (this._picker) {
            this._picker.hide();
        }
    }

    public update(position) {
        this._picker.update(position);
        this.setMovePos();
        this.setSpinPos();
    }

    public targetObject() {
        return this._picker.getTargetObject();
    }

    public targetPoint() {
        return this._picker.getTargetPoint();
    }

    public changeTargetObject(object: THREE.Object3D) {
        this._picker.setTargetObject(object);
    }

    // 移動アイコンの表示位置をコントローラーに設定
    public setMovePos() {
        if (!this.visible()) return;

        const dragController = <ModelDragController>ThreeView.get().ItemDragManager.dragController;
        if (dragController.controller instanceof IconDragControls
            || dragController.controller instanceof IconWallItemDragControls) {
            const element = document.getElementById('pick1_moveBtn'); // picker位置
            const clientRect = element.getBoundingClientRect(); // 画面内の位置
            dragController.controller.setPicker(clientRect, 40, 40);
        }
    }

    // 回転アイコンの表示位置をコントローラーに設定
    public setSpinPos() {
        if (!this.visible()) return;
        const dragController = <ModelDragController>ThreeView.get().ItemDragManager.dragController;
        if (dragController.controller instanceof IconWallItemDragControls) return;

        const rotateController = <ModelRotateController>ThreeView.get().ItemDragManager.rotateController;
        if (rotateController.transFormControls instanceof IconTransformControls) {
            const element = document.getElementById('pick1_spinBtn'); // picker位置
            if (element == null) return;
            const clientRect = element.getBoundingClientRect(); // 画面内の位置
            rotateController.transFormControls.setPicker(clientRect, 40, 40);
        }
    }
}
